import {
    serverBus
} from '@/main';
import Global from '@/scripts/Global'
import MyAccount from '@/components/overlay/UserProfile/MyAccount/MyAccount.vue'
import UserApi from '@/scripts/api/user.api';
import SessionManager from '@/Manager/Session.manager';
import VueSignals from '@/scripts/VueSignals';

let oImage = null
export default {
    name: 'Profile',
    data() {
        return {
            folders: [],
            mainSpinner: false,
            overlayType: Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
            SettingsTemplates: {
                'MyAccount': 'My Account',
            },
            ActiveTemplate: 'MyAccount',
            loggedInUser: SessionManager.getLoggedInUser(),
            CPURL: Global.GetPortalURL(),
            windowWidth: window.innerWidth
        }

    },
    components: {
        MyAccount,
    },
    mounted() {
        serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
            this.overlayType = overlayType
        })
    },
    created() {
        serverBus.$on(VueSignals.SHOW_MODAL, (modalStatus) => {
            this.showModal = modalStatus;
        })
    },
    methods: {
        ActionButton(key) {
            if (key != 'Logout') {
                this.ActiveTemplate = key
            } else {
                UserApi.logout().then(res => {
                    if (res.data.result) {
                        window.location.href = window.location.href.slice(0, window.location.href.indexOf('/channel'))
                        Global.logout()
                    }
                })
            }

        }
    }
}
